module.exports = __webpack_public_path__ + "static/media/editProfileIcon.e1db5081.svg";